import LeftPanelCloseIcon from "../../../images/left_panel_close_icon.svg?react";
import LeftPanelOpenIcon from "../../../images/left_panel_open_icon.svg?react";
import "./PageContentWithLeftSidebar.css";
import { FC, ReactNode } from "react";
import classnames from "classnames";

interface IPageContentWithLeftSidebar {
  openSidebar?: boolean;
  containerClass?: string;
  subHeader?: ReactNode;
  leftSidebar: ReactNode;
  pageContent: ReactNode;
  onToggleSidebar?: () => void;
  isLessonPage?: boolean;
  isSidebarHidden?: boolean;
}

const PageContentWithLeftSidebar: FC<IPageContentWithLeftSidebar> = ({
  openSidebar = true,
  containerClass = "page-content-with-left-sidebar",
  subHeader,
  leftSidebar,
  pageContent,
  onToggleSidebar,
  isLessonPage,
  isSidebarHidden,
}) => {
  return (
    <div className={containerClass}>
      <div className="sub-header">{subHeader}</div>
      <div className={`main-content ${isLessonPage ? "main-content-lesson" : ""}`}>
        {!isSidebarHidden && (
          <div className={classnames("left-sidebar", { opened: openSidebar })}>
            {onToggleSidebar && (
              <button className="toggle-sidebar-button" onClick={onToggleSidebar}>
                {openSidebar ? <LeftPanelCloseIcon /> : <LeftPanelOpenIcon />}
              </button>
            )}
            {leftSidebar}
          </div>
        )}
        <div className="content-grow">{pageContent}</div>
      </div>
    </div>
  );
};

export default PageContentWithLeftSidebar;
